import messages from './messages.json';
import formatDateWithLocale from './formatDateWithLocale';

const getJobDetails = (job, intl, locale) => {
  const location = locale === 'en-US'
    ? [job.city, job.addressRegion, job.postalCode]
      .filter(Boolean)
      .join(', ')
    : job.city;

  return [
    {
      label: `${intl.formatMessage(messages['jobView.JobTitle'])}: `,
      value: job.title,
    },
    {
      label: `${intl.formatMessage(messages['jobView.companyName'])}: `,
      value: job.company.displayName,
    },
    {
      label: `${intl.formatMessage(messages['jobView.location'])}: `,
      value: location,
    },
    {
      label: `${intl.formatMessage(messages['jobView.countryName'])}: `,
      value: job.country,
    },
    {
      label: `${intl.formatMessage(messages['jobView.howToApply'])}: `,
      value: 'FashionUnited',
    },
    {
      label: `${intl.formatMessage(messages['jobView.datePost'])}: `,
      value: formatDateWithLocale(new Date(job.publishedAt), locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
    },
  ];
};

export default getJobDetails;
